// Persisted domain configs carry this. Bump CURRENT_SCHEMA_VERSION and register a
// migration below when the DomainConfiguration shape changes.
import { migrateInterfaceOption } from '../utils/migration';

export const CURRENT_SCHEMA_VERSION = 2;

// A migration upgrades a raw persisted config from version N to version N+1,
// keyed by the FROM version.
export type SchemaMigration = (raw: Record<string, unknown>) => Record<string, unknown>;

export const SCHEMA_MIGRATIONS: Record<number, SchemaMigration> = {
  // v1 -> v2 (CONF-93): the single Ethernet/Infiniband interfaceOption becomes a
  // five-value network speed plus a separate networkProtocol.
  1: (raw) => migrateInterfaceOption(raw) as Record<string, unknown>,
};
